module.exports = __webpack_public_path__ + "img/nav.465a7015.svg";